import * as React from 'react';
import classnames from 'classnames';

const ProductBlockOuter = /*#__PURE__*/ React.forwardRef(({ className , children  }, ref)=>{
    return /*#__PURE__*/ React.createElement("article", {
        ref: ref,
        className: classnames('v2-product-block-outer', className)
    }, children);
});

export { ProductBlockOuter };
//# sourceMappingURL=ProductBlockOuter.js.map
